import { useServerInsertedHTML } from 'next/navigation';

import { useState } from 'react';

import createCache from '@emotion/cache';

/**
 * Hook that properly handles cache for styles (server and client side)
 */
export const useEmotionCache = (key = 'css') => {
    const [{ cache, flush }] = useState(() => {
        const cache = createCache({ key: 'css' });
        cache.compat = true;
        const prevInsert = cache.insert.bind(cache);
        let inserted: string[] = [];

        cache.insert = (...args: Parameters<typeof prevInsert>) => {
            const serialized = args[1];
            if (cache.inserted[serialized.name] === undefined) {
                inserted.push(serialized.name);
            }
            return prevInsert(...args);
        };

        const flush = () => {
            const prevInserted = inserted;
            inserted = [];
            return prevInserted;
        };

        return { cache, flush };
    });

    useServerInsertedHTML(() => {
        const names = flush();
        if (!names.length) return null;

        let styles = '';
        for (const name of names) {
            styles += cache.inserted[name] as string;
        }

        return (
            <style
                data-emotion={`${cache.key} ${names.join(' ')}`}
                dangerouslySetInnerHTML={{ __html: styles }}
            />
        );
    });

    return {
        cache,
    };
};
